import { Outlet, Navigate } from 'react-router-dom'
import { useAuth } from '../context/useAuth'

const LoginRoutes = () => {
  const { auth } = useAuth()
  if (auth.isInitialized) return null
  return auth.isAuthenticated ? <Navigate to='/' /> : <Outlet />
}

export default LoginRoutes
